





































































import { Component, Vue } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class Recharge extends Vue {
  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }
  private banksInfo: any = [
    { id: 1, ownerName: 'Nguyễn Đức Thịnh', bankNumber: '99868386888', branchName: 'TP bank', qrCode: 'img/icons/tpbank-qr.jpg?v=2'},
    { id: 2, ownerName: 'Nguyễn Đức Thịnh', bankNumber: '6789858699999', branchName: 'MB Bank', qrCode: 'img/icons/mb-bank-qr-v2.jpg?v=3' },
    { id: 3, ownerName: 'Nguyễn Đức Thịnh', bankNumber: '88885869999', branchName: 'VP bank', qrCode: 'img/icons/vp-qr.jpg' },
  ];
  private bankSelected = this.banksInfo.find(x => x.id === 1);
  private async onSelectBank(bankId: number) {
    this.bankSelected = this.banksInfo.find(x => x.id === bankId);
  }

}
